import { useMutation, useQueryClient } from '@tanstack/react-query';
import authAxios from '@services/authAxios';
import { useSnackbarNotification } from '@store/snackbarNotification';

const useMutateStoreConfig = () => {
    const queryClient = useQueryClient();
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    const updateCP = useMutation({
        mutationFn: async ({ id, payload }) => {
            const { data } = await authAxios.patch(`/api/v1/parahub-store-config/${id}`, payload);
            return data;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries(['store-config-list']);
            onChangeSnackbarNotification({
                status: 'success',
                description: 'Konfigurasi Parahub Berhasil Disimpan.',
                duration: 3,
            });
        },
        onError: (error) => {
            const msg = error.response.data.message;

            if (msg) {
                onChangeSnackbarNotification({
                    status: 'error',
                    title: 'Konfigurasi Parahub Gagal diedit.',
                    description: msg,
                    duration: 3,
                });
            } else {
                onChangeSnackbarNotification({
                    status: 'error',
                    title: 'Konfigurasi Parahub Gagal diedit.',
                    description: 'hubungi admin/service desk IT',
                    duration: 3,
                });
            }
        },
    });

    return {
        updateCP,
    };
};

export default useMutateStoreConfig;
